// extracted by mini-css-extract-plugin
export default {"sealsContainer":"sealsContainer___gX_p5","sealContainer":"sealContainer___NP0AR"};